<div class="content">
  <div class="mt-2">
    <h1>{{selectedPlan?.title || ''}}</h1>
    <br>

    <div class="d-flex flex-row flex-wrap">
      <p class="pl-3 text-justify pt-1 ms-2" [innerHTML]="selectedPlan?.description | urlDecoder"></p>
    </div>
    <br>
    <h5>Additional Features</h5>
    <div class="flex justify-content-start align-items-start m-0 ms-1">
      <div class="m-0" style="font-size: 14px; line-height: 1.5; list-style: none;">
        <div>- Free Trial</div>
        <div>- Pay only for software</div>
        <div>- Deploy inside your subscription (No VNET Peering)</div>
        <div>- Fully automated deployment with Azure PowerShell</div>
        <div>- Download and deploy yourself</div>
      </div>
    </div>

  </div>




</div>

<div class='footer'>

  <button class="btn btn-sm btn-nc btn-outline-primary az-btn-space btn-width" (click)="onPrevious()"
    [disabled]="this.isActivatingPlan" *ngIf="this.isShowPrevious()">
    Previous
  </button>

  <button class="btn btn-nc az-btn-space btn-sm submit btn-primary btn-width" (click)="onConfirmPlan()"
    [disabled]="this.isActivatingPlan">
    Confirm
  </button>

  <button class="btn btn-sm btn-nc btn-outline-primary az-btn-space btn-width" (click)="goToDashboard()">
    Cancel
  </button>

</div>